import { WireToInformationFieldId } from 'app/pages/loanApplication/tabs/loanClosingCDS/EditDrawer/Content/Content.constants';
import { getFundingInformationFormConfig } from 'app/pages/loanApplication/tabs/loanClosingCDS/EditDrawer/EditDrawer.config';
import _ from 'lodash';

import { FUNDING_FORM_PATH } from './LoanEditorCustomFormDrawer.constants';
import {
  checkIsEntityAvailable,
  flattenGroupFields,
  toDrawerEntityField,
} from './LoanEditorCustomFormDrawer.entity.utils';

const EXCLUDED_FUNDING_FIELD_IDS = new Set([WireToInformationFieldId.FEE_PROVIDER_ID]);

const getFundingFields = fundingContext =>
  flattenGroupFields(
    getFundingInformationFormConfig({
      warehouseBankOptions: fundingContext.warehouseBankOptions ?? [],
      feeProviderOptions: [],
      isUnsecured: fundingContext.isUnsecured,
    }).groups,
  ).map(field =>
    toDrawerEntityField({
      field,
      formPath: FUNDING_FORM_PATH,
      isDisabled: !fundingContext.isEditAllowed || fundingContext.isLockGatedFieldsDisabled,
    }),
  );

export const FUNDING_FIELD_NAMES = new Set(
  getFundingFields({ isEditAllowed: true })
    .map(({ fieldId }) => fieldId)
    .filter(fieldId => !EXCLUDED_FUNDING_FIELD_IDS.has(fieldId)),
);

export const getFundingSeedFields = fundingContext =>
  checkIsEntityAvailable(fundingContext) ? getFundingFields(fundingContext) : [];

export const getFundingConfigFieldsForContext = fundingContext =>
  _.keyBy(
    getFundingSeedFields(fundingContext).filter(field => FUNDING_FIELD_NAMES.has(field.fieldId)),
    'fieldId',
  );
